import {NgModule} from "@angular/core";
import {NgChartsCommonModule} from "../common/ng-charts-common.module";
import {LinearGaugeComponent} from "./linear-gauge.component";
import {GaugeComponent} from "./gauge.component";
import {GaugeArcComponent} from "./gauge-arc.component";
import {GaugeAxisComponent} from "./gauge-axis.component";
import {NgPieChartModule} from "../pie-chart/ng-pie-chart.module";
import {NgBarChartModule} from "../bar-chart/ng-bar-chart.module";

export {GaugeComponent, GaugeArcComponent, GaugeAxisComponent, LinearGaugeComponent};

@NgModule({
    imports: [
        NgChartsCommonModule,
        NgPieChartModule,
        NgBarChartModule],
    declarations: [
        LinearGaugeComponent,
        GaugeComponent,
        GaugeArcComponent,
        GaugeAxisComponent
    ],
    exports: [
        LinearGaugeComponent,
        GaugeComponent,
        GaugeArcComponent,
        GaugeAxisComponent
    ]
})
export class NgGaugeModule {
}
